'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('MfaAuthCodeCtrl', MfaAuthCodeCtrl);
  MfaAuthCodeCtrl.$inject = ['$scope', '$stateParams', 'authenticationSvc', 'userSvc', 'onboardingRouter', '$log', 'msAuth'];

  function MfaAuthCodeCtrl($scope, $stateParams, authenticationSvc, userSvc, onboardingRouter, $log, msAuth) {
    var vm = this;
    $scope.flip = false;
    $scope.user = {};
    $scope.verify = _verify;
    $scope.resend = _send;
    $scope.dismiss = _dismiss;
    $scope.sentCount = 0;
    $scope.showResent = false;
    $scope.$watch('user', function () {
      $scope.invalid = false;
    }, true);

    _activate();

    function _activate() {
      _send();
    }

    function _send() {
      userSvc.sendAuthCode().then(function (resp) {
        vm.authType = resp;
        $scope.sentCount++;
        if ($scope.sentCount > 1) {
          $scope.showResent = true;
        }
      });
    }

    function _dismiss() {
      $scope.showResent = false;
    }

    function _verify() {
      $scope.form.processing = true;
      $scope.invalid = false;
      msAuth.mfa($scope.user.verificationCode).then(_onVerifySuccess, _onVerifyError);
    }

    function _onVerifySuccess(resp) {
      $scope.form.processing = false;
      authenticationSvc.onLoginSuccess(resp);
      onboardingRouter.navigateRedirect({ redirecturl: authenticationSvc.getDashboardUrl() });
    }

    function _onVerifyError(err) {
      $scope.form.processing = false;
      $log.debug(err);
      $scope.invalidCopy = 'login.verificationCode.invalid';
      $scope.invalid = true;
    }
  }
})();